import { useEffect } from 'react';

import { GetPdpBaseInfo_catalog_product_base_info_product_managed_category_list } from '../../graphql/pdp-base-info_types.2';
import { usePdpWebEvents } from '../../hooks/usePdpWebEvents';

interface Props {
  disableLogging?: boolean;
  pageViewEventInfo: {
    params: PageViewParams;
    enabledAirbridge: boolean;
  };
}

interface PageViewParams {
  product_id: string;
  price: number;
  product_name: string;
  quantity: number;
  category: string;
  shop_id: string;
  shop_name: string;
  managedCategoryList: (GetPdpBaseInfo_catalog_product_base_info_product_managed_category_list | null)[] | null;
}

export const PdpPageviewEventLog: React.FC<React.PropsWithChildren<Props>> = ({ children, disableLogging, pageViewEventInfo }) => {
  const { pageViewEvent } = usePdpWebEvents();

  useEffect(() => {
    if (!disableLogging) {
      pageViewEvent(pageViewEventInfo.params, { enabledAirbridge: pageViewEventInfo.enabledAirbridge });
    }
  }, [disableLogging]);

  return <>{children}</>;
};
